// extracted by mini-css-extract-plugin
export default {"icon":"drawer-footer-animated-icon_icon__3hjZ2"};